export default "__VITE_ASSET__DAZRvqNm__"